export const secret = '8caa0e76-a361-4fad-b195-8e002fd99a9c'
// export const secret = localStorage?.getItem("ok");